module.exports = __webpack_public_path__ + "img/27600.86211100.jpg";